import type { ComponentProps } from "react";
import * as ContextMenu from "zeego/context-menu";

export const MenuItem = ContextMenu.create(
    ({ style, ...itemProps }: ComponentProps<typeof ContextMenu.Item>) => (
        <ContextMenu.Item
            {...itemProps}
            style={{
                height: 44,
                paddingLeft: 16,
                paddingRight: 16,
                paddingTop: 12,
                paddingBottom: 12,
                ...style,
            }}
        />
    ),
    "Item",
);
